import React from 'react';

import AnalyticsSvg from 'assets/images/analytics.svg';

import BaseIcon from './BaseIcon';

const AnalyticsIcon = props => <BaseIcon {...props} src={AnalyticsSvg} />;

export default AnalyticsIcon;
